import React, { useState } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Badge, Label, Row, Col } from 'reactstrap';
import { BsXCircle } from 'react-icons/bs';
import styles from "./MultiSelect.module.scss";

const MultiSelect = ({ options, label, selected, onChange, toggleModal, setModalContent, setModalAction }) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

    const handleOptionChange = (option) => {
        const updatedOptions = selected.includes(option)
            ? selected.filter((o) => o !== option)
            : [...selected, option];

        onChange(updatedOptions);
    };

    const handleRemoveOption = (option) => {
        setModalContent({
            title: 'Confirm Deletion',
            body: `Are you sure you want to delete the option "${option}"? It will be removed from the combinations as well.`,
            confirmText: 'Yes, Delete',
            cancelText: 'Cancel',
        });

        setModalAction(() => () => {
            const updatedOptions = selected.filter((item) => item !== option);
            onChange(updatedOptions);
        });

        toggleModal();
    };

    return (
        <Row className={styles.multiSelectContainer}>
            <Col lg={3} xl={2}>
                <Label>{label}:</Label>
            </Col>

            <Col lg={5} xl={6}>
                <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown} className={styles.multiSelectDropdown}>
                    <DropdownToggle className={styles.multiSelectToggle} caret>
                        {label}
                    </DropdownToggle>
                    <DropdownMenu className={styles.multiSelectMenu}>
                        {options.map((option) => {
                            const isActive = selected.includes(option);
                            return (
                                <DropdownItem
                                    key={option}
                                    onClick={() => handleOptionChange(option)}
                                    active={isActive}
                                    className={styles.multiSelectMenuOption}
                                    style={{
                                        backgroundColor: isActive ? '#41B8E4' : 'transparent',
                                        color: isActive ? '#ffffff' : '#1A2425',
                                    }}
                                >
                                    {option}
                                </DropdownItem>
                            );
                        })}
                    </DropdownMenu>
                </Dropdown>
            </Col>

            {selected.length > 0 &&
                <Col lg={4} xl={4}>
                    <div className={styles.selectedOptions}>
                        {selected.map((option) => (
                            <div key={option} className={styles.selectedBadge}>
                                {option}
                                <BsXCircle className={styles.removeIcon} onClick={() => handleRemoveOption(option)} />
                            </div>
                        ))}
                    </div>
                </Col>
            }
        </Row>
    );
};

export default MultiSelect;